import { Component, HostBinding, HostListener, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { Subscription } from 'rxjs/Subscription';
import * as debug from 'debug';
import { JackpotService } from '@app/core/jackpot.service';
import { Router } from '@angular/router';

const log = debug('edg:jackpot-header');

@Component({
  selector: 'app-jackpot-header-new',
  templateUrl: './jackpot-header.template.html',
  styleUrls: ['./jackpot-header.template.scss'],
  host: {
    '(click)': 'navigate($event)',
  },
})
export class JackpotHeaderNewComponent implements OnInit, OnChanges, OnDestroy {
  jackpotValue: any = [];
  ends: any = {
    days: 0,
    hours: 0,
    minutes: 0,
  };

  timeout: any = null;

  constructor(public auth: AuthenticationService, private jackpotService: JackpotService, private router: Router) {}

  ngOnInit() {
    let date = new Date(this.jackpotService._jackpotInfo.finishAt);
    this.buildJackpotDate(date.getTime());

    this.buildJackpotValue(this.jackpotService._jackpotInfo.rewardTokenAmount);
  }

  ngOnChanges() {}

  ngOnDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  navigate(event: any) {
    this.router.navigate(['/jackpot']);
  }

  buildJackpotDate(date: any) {
    const now = new Date().getTime();
    const dateDiff = date - now;
    this.ends = {
      days: Math.floor(dateDiff / (1000 * 60 * 60 * 24)),
      hours: Math.floor(dateDiff / (1000 * 60 * 60)) % 24,
      minutes: Math.ceil(dateDiff / (1000 * 60)) % 60,
    };

    if (dateDiff < 0) {
      this.jackpotService.getInfo();
    } else {
      this.timeout = setTimeout(() => {
        this.buildJackpotDate(date);
      }, 60000);
    }
  }

  isNumber(val) {
    return typeof val === 'number';
  }

  buildJackpotValue(num: number) {
    this.jackpotValue = [];
    const numString = num.toString();
    for (let i = numString.length; i > 0; i--) {
      if (this.jackpotValue.filter(item => this.isNumber(item)).length % 3 === 0 && this.jackpotValue.length !== 0) {
        this.jackpotValue.push(',');
      }
      this.jackpotValue.push(Number(numString[i - 1]));
    }
    this.jackpotValue.reverse();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/header-navigation/jackpot-header-new/jackpot-header.component.ts